var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { useFormControl } from "@material-ui/core/FormControl";
export var getHiddenLabelStyles = function (spacing) { return ({
    opacity: 0,
    transform: "translate(".concat(spacing(-2), "px, calc(").concat(spacing(4), "px - 50%))"),
}); };
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography, transitions = _a.transitions;
    return ({
        root: __assign(__assign({}, typography.button), { lineHeight: 1, position: "static", marginBottom: "-1em", alignSelf: "flex-start", pointerEvents: "none", marginLeft: spacing(10), maxWidth: "calc(100% - ".concat(spacing(10) - 1, "px)"), paddingRight: spacing(4), 
            // Truncates the label when space is limited
            textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", "&&": {
                // Height value pulled from MuiInputBase
                transform: "translate(0px, calc(".concat(spacing(4), "px - 50%))"),
                color: function (_a) {
                    var color = _a.color;
                    return color === "primary"
                        ? palette.primary.contrastText
                        : palette.secondary.contrastText;
                },
                transition: transitions.create(["opacity", "transform"], {
                    duration: transitions.duration.standard,
                }),
            } }),
        expanded: getHiddenLabelStyles(spacing),
    });
}, { name: "EuiCollapseFieldLabel" });
export var CollapseFieldLabel = React.forwardRef(function CollapseField(_a, ref) {
    var _b;
    var className = _a.className, props = __rest(_a, ["className"]);
    var _c = useFormControl() || {}, filled = _c.filled, focused = _c.focused, color = _c.color;
    var classes = useStyles({ color: color });
    return (React.createElement(InputLabel, __assign({ className: clsx(classes.root, className, (_b = {},
            _b[classes.expanded] = filled || focused,
            _b)) }, props, { shrink: false, ref: ref })));
});
//# sourceMappingURL=CollapseFieldLabel.js.map